import { z } from "zod";
import { Connector } from "./Connection.js";
import {
  MemoryFactEdgeMetadataSchema,
  MemoryFactNodeContentSchema,
} from "./FactNodes/MemoryFactNode.js";
import {
  NoteFactNodeContentSchema,
  NoteOnPersonFactEdgeMetadataSchema,
} from "./FactNodes/NoteFactNode.js";
import { OrganizationFactNodeContentSchema } from "./FactNodes/OrganizationFactNode.js";
import {
  PersonFactNodeContentSchema,
  PersonKnowsFactEdgeMetadataSchema,
  PersonWorksAtFactEdgeMetadataSchema,
} from "./FactNodes/PersonFactNode.js";
import {
  RootConnectsWithFactEdgeMetadataSchema,
  RootFactNodeContentSchema,
} from "./FactNodes/RootFactNode.js";

export enum FactNodeOrigin {
  Api = "api",
  App = "app",
  ExternalUnknown = "external-unknown",
  FileImport = "file-import",
  GoogleAnalytics = Connector.GoogleAnalytics,
  GoogleDrive = Connector.GoogleDrive,
  Stripe = Connector.Stripe,
  Zapier = Connector.Zapier,
}

export const FactNodeContentSchema = z.discriminatedUnion("nodeType", [
  RootFactNodeContentSchema,
  OrganizationFactNodeContentSchema,
  MemoryFactNodeContentSchema,
  PersonFactNodeContentSchema,
  NoteFactNodeContentSchema,
]);

export const FactNodeSchema = z.object({
  id: z.uuid(),
  creatorId: z.uuid().nullable(),
  organizationId: z.uuid(),
  nodeType: z.string(),
  content: FactNodeContentSchema,
  private: z.boolean(),
  origin: z.string(),
  createdByAssistant: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date().nullable(),
  removedAt: z.date().nullable(),
});

export const FactEdgeMetadataSchema = z.discriminatedUnion("edgeType", [
  MemoryFactEdgeMetadataSchema,
  PersonKnowsFactEdgeMetadataSchema,
  PersonWorksAtFactEdgeMetadataSchema,
  NoteOnPersonFactEdgeMetadataSchema,
  RootConnectsWithFactEdgeMetadataSchema,
]);

export const FactEdgeSchema = z.object({
  id: z.uuid(),
  organizationId: z.uuid(),
  edgeType: z.string(),
  metadata: FactEdgeMetadataSchema,
  sourceId: FactNodeSchema.shape.id,
  targetId: FactNodeSchema.shape.id,
});

export type FactNode = z.infer<typeof FactNodeSchema>;
export type FactNodeContent = z.infer<typeof FactNodeContentSchema>;
export type FactEdge = z.infer<typeof FactEdgeSchema>;
export type FactEdgeMetadata = z.infer<typeof FactEdgeMetadataSchema>;
